<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-6">
        <div class="card h-100 mb-4">
          <div class="card-header pb-0 px-3">
            <div class="row">
              <div class="col-md-6">
                <h6 class="mb-0">Procesos Disponibles</h6>
              </div>
              <div class="col-md-6 d-flex justify-content-end align-items-center">
                <soft-input
                  v-model="searchQuery"
                  placeholder="Buscar proceso..."
                  icon="fas fa-search"
                  iconDir="left"
                  size="sm"
                  class="mb-0"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-4 p-3">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Título</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Creado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in filteredProcesses" :key="index">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ item.title }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">{{ $filters.formatDate(item.created_at) }}</p>
                    </td>
                    <td class="align-middle text-center">
                      <soft-button
                        color="success"
                        variant="outline"
                        size="sm"
                        class="mb-0 py-1 px-3"
                        @click="addProcess(item._id)"
                      >
                        <i class="fas fa-plus me-1"></i> Asignar
                      </soft-button>
                    </td>
                  </tr>
                  <tr v-if="filteredProcesses.length === 0">
                    <td colspan="3" class="text-center py-4">
                      <p class="text-xs text-secondary mb-0">No se encontraron procesos disponibles</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card h-100 mb-4">
          <div class="card-header pb-0 px-3">
            <h6 class="mb-0">Procesos Asignados al Usuario</h6>
          </div>
          <div class="card-body pt-4 p-3">
            <soft-alert v-if="primary_process_user.length === 0" color="info" icon="fas fa-info-circle">
              El usuario aún no tiene procesos asignados
            </soft-alert>
            <div v-else class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Título</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Fecha Asignación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in primary_process_user" :key="index">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ item.main_process_title }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">{{ $filters.formatDate(item.created_at) }}</p>
                    </td>
                    <td class="align-middle text-center">
                      <soft-button
                        color="danger"
                        variant="outline"
                        size="sm"
                        class="btn-icon-only shadow-none mb-0"
                        title="Eliminar asignación"
                        @click="deleteProcessAssigned(item._id)"
                      >
                        <i class="fas fa-trash"></i>
                      </soft-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, post } from "@/utils/httpRequest";
import Swal from "sweetalert2";
import SoftButton from "@/components/SoftButton.vue";
import SoftInput from "@/components/SoftInput.vue";
import SoftAlert from "@/components/SoftAlert.vue";

export default {
  name: "tabAddProcess",
  components: {
    SoftButton,
    SoftInput,
    SoftAlert
  },
  data: () => ({
    user_id: null,
    primary_process: [],
    primary_process_user: [],
    searchQuery: ""
  }),
  computed: {
    filteredProcesses() {
      if (!this.searchQuery) return this.primary_process;
      const query = this.searchQuery.toLowerCase();
      return this.primary_process.filter(p => 
        p.title && p.title.toLowerCase().includes(query)
      );
    }
  },
  mounted() {
    this.user_id = this.$route.query.id
    this.getMainProcessByUser()
    this.getPrimaryProcessData()
  },
  methods: {
    async getMainProcessByUser() {
      try {
        const { data } = await get(`main-process/get-main-process-by-user?user_id=${this.user_id}`)
        this.primary_process_user = data
      } catch (error) {
        console.error("Error fetching user processes:", error)
      }
    },
    async getPrimaryProcessData() {
      try {
        const { data } = await get('main-process', null)
        this.primary_process = data.docs || data
      } catch (error) {
        console.error("Error fetching primary processes:", error)
      }
    },
    async deleteProcessAssigned(_id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: "Se eliminará la asignación de este proceso para el usuario",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#82d616',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      })

      if (result.isConfirmed) {
        try {
          await post(`main-process/delete-main-process-assigned`, { _id: _id })
          await Swal.fire({
            title: 'Eliminado',
            text: 'Proceso desvinculado correctamente',
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          await this.getMainProcessByUser()
        } catch (error) {
          Swal.fire('Error', 'No se pudo eliminar la asignación', 'error')
        }
      }
    },
    async addProcess(_id) {
      try {
        await post("main-process/assign-main-process", { _id: _id, user_id: this.user_id })
        await Swal.fire({
          title: 'Asignado',
          text: 'Proceso asignado correctamente',
          icon: 'success',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        })
        await this.getMainProcessByUser()
      } catch (error) {
        Swal.fire('Error', 'No se pudo asignar el proceso', 'error')
      }
    }
  }
}
</script>

<style scoped>
.table thead th {
  padding: 0.75rem 1.5rem;
}
.table tbody td {
  padding: 0.75rem 1.5rem;
}
</style>
